export default {"src":"/uk/_next/static/media/more-meatball-menu.3f445111.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};